





























import { Component, Vue, Prop } from 'vue-property-decorator'
import { GamePlayerData } from '@/class/gamePlayer'
import { RoleId, CauseOfDeath } from '@/enum'
import CardArea from '@/components/Game/Common/CardArea.vue'

@Component({
  components: {
    CardArea
  }
})
export default class Player extends Vue {
  @Prop() player!: GamePlayerData;

  get name () {
    return this.player.name
  }

  get hasBomb () {
    return this.player.bomb
  }

  get isAteCrab () {
    return this.player.status.eatCrab
  }

  get isTempted () {
    return this.player.status.tempted
  }

  get isSwindled () {
    return this.player.status.swindled
  }

  get isGuard () {
    return this.player.status.guard
  }

  get isStolen () {
    return this.player.status.stolen
  }

  get isPunished () {
    return this.player.deathDetails?.cause === CauseOfDeath.punished
  }

  get isKilled () {
    return this.player.deathDetails && this.player.deathDetails.cause !== CauseOfDeath.punished
  }

  get showsBulletCount(): boolean {
    return this.player.roleId === RoleId.sniper
  }

  get showsArmorCount(): boolean {
    return this.player.roleId === RoleId.survivor
  }

  get showsStealCount(): boolean {
    return this.player.roleId === RoleId.pickpocket
  }

  get showsShieldCount(): boolean {
    return this.player.roleId === RoleId.bomber
  }
}
